import React, { useEffect, useState } from "react";
import { Box, Card, CardContent } from "@mui/material";
import { Button, DateField, EmailField, FunctionField, SimpleShowLayout, TopToolbar, useRedirect } from "react-admin";
import PasswordIcon from "@mui/icons-material/VpnKey";
import authProvider from "../authProvider";

const MyProfile = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const redirect = useRedirect();

  useEffect(() => {
    if(authProvider){
      authProvider
      .checkAuth()
      .then(() => {})
      .catch(() => {
        redirect("/login")
      });
    }
  }, [authProvider]);
 

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/users/me`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setUser(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, margin: 0 }}>
        <TopToolbar>
            <Button
                label="パスワード変更"
                onClick={() => redirect("/change-password")}
                startIcon={<PasswordIcon />}
            />
        </TopToolbar>
    </Box>
  );

  return (
    <>
        <CustomTopToolbar/>
        <Card>
        <CardContent>
            <SimpleShowLayout record={user}>
                <FunctionField source="userName" label="ユーザー名" render={record => {return record.userName}} />
                <FunctionField source="name" label="名前" render={record => {return record.name}}/>
                <EmailField source="mail" label="メール" type="email" />
                <FunctionField
                    label="権限"
                    render={record => {
                    switch (record.userType) {
                        case 0:
                        return "一般スタッフ";
                        case 1:
                        return "管理スタッフ";
                        // case 2:
                        // return "マスター";
                        default:
                        return "不明な権限";
                    }
                    }}
                />
                <DateField source="createDate" label="登録日" />
            </SimpleShowLayout>
        </CardContent>
        </Card>
    </>

  );
};

export default MyProfile;
